<style lang="less">
.setting-title {
    font-size: 20px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    margin-bottom: 25px;
}

.json-editor {
  width: 100%;
  min-height: 500px;
  font-family: 'Courier New', Consolas, monospace;
  font-size: 14px;
  line-height: 1.6;
  padding: 12px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  resize: vertical;
  outline: none;
  &:focus {
    border-color: #57a3f3;
    box-shadow: 0 0 0 2px rgba(45, 140, 240, 0.2);
  }
}
</style>
<template>
  <div>
    <Card>
      <div class="setting-title">uniApp系统配置维护</div>
      <Alert type="info" show-icon style="margin-bottom: 16px;">
        每个页面独立配置，以 JSON 格式存储于 Redis 键
        <strong>sys:union:config:{page}</strong>，
        并持久化到文件。修改后请点击保存。
      </Alert>
      <div style="margin-bottom: 16px; display: flex; align-items: center;">
        <span style="margin-right: 12px;">选择页面：</span>
        <Select v-model="currentPage" style="width: 200px;" @on-change="onPageChange">
          <Option v-for="p in pages" :key="p" :value="p">{{ p }}</Option>
        </Select>
        <Button size="small" @click="loadPages" :loading="loadingPages" style="margin-left: 12px;">刷新列表</Button>
      </div>
      <div style="margin-bottom: 16px;">
        配置内容（JSON 格式）：
        <Tooltip content="点击格式化" placement="right">
          <Button size="small" @click="formatJson" style="margin-left: 8px;">格式化</Button>
        </Tooltip>
        <Button size="small" @click="loadConfig" :loading="loading" style="margin-left: 8px;">刷新</Button>
      </div>
      <textarea
        class="json-editor"
        v-model="configJson"
        placeholder="请填写 JSON 格式的配置数据..."
        :rows="20"
      ></textarea>
      <div style="margin-top: 16px;">
        <Button type="primary" :loading="saving" @click="handleSave" style="width: 120px;">保存配置</Button>
        <span v-if="saveStatus" :style="{ marginLeft: '12px', color: saveStatusColor }">{{ saveStatus }}</span>
      </div>
      <Spin fix v-if="loading"></Spin>
    </Card>
  </div>
</template>

<script>
import { getRequest, postRequest } from '@/libs/axios';

export default {
  name: 'uniApp-config',
  data() {
    return {
      loading: false,
      saving: false,
      loadingPages: false,
      currentPage: '',
      pages: [],
      configJson: '',
      saveStatus: '',
      saveStatusColor: ''
    };
  },
  methods: {
    loadPages() {
      this.loadingPages = true;
      getRequest('/uniapp/sys/uniappConfig/pages').then(res => {
        this.loadingPages = false;
        if (res.success && res.result) {
          this.pages = res.result;
          // 默认选中第一个页面
          if (this.pages.length > 0 && !this.currentPage) {
            this.currentPage = this.pages[0];
            this.loadConfig();
          }
        }
      }).catch(() => {
        this.loadingPages = false;
        this.$Message.error('获取页面列表失败');
      });
    },
    onPageChange() {
      this.configJson = '';
      this.saveStatus = '';
      if (this.currentPage) {
        this.loadConfig();
      }
    },
    loadConfig() {
      if (!this.currentPage) return;
      this.loading = true;
      this.saveStatus = '';
      getRequest('/uniapp/sys/uniappConfig', { page: this.currentPage }).then(res => {
        this.loading = false;
        if (res.success && res.result) {
          this.configJson = JSON.stringify(res.result, null, 2);
        } else {
          this.configJson = '';
          this.$Message.info('暂无配置数据');
        }
      }).catch(() => {
        this.loading = false;
        this.$Message.error('获取配置失败');
      });
    },
    formatJson() {
      try {
        const obj = JSON.parse(this.configJson);
        this.configJson = JSON.stringify(obj, null, 2);
        this.saveStatus = '格式化成功';
        this.saveStatusColor = '#19be6b';
      } catch (e) {
        this.saveStatus = 'JSON 格式有误，无法格式化';
        this.saveStatusColor = '#ed4014';
      }
    },
    handleSave() {
      if (!this.currentPage) {
        this.$Message.warning('请先选择一个页面');
        return;
      }
      // 先校验 JSON
      try {
        JSON.parse(this.configJson);
      } catch (e) {
        this.$Message.error('JSON 格式有误，请检查后再保存');
        return;
      }
      this.saving = true;
      this.saveStatus = '';
      postRequest('/uniapp/sys/uniappConfig/set', {
        page: this.currentPage,
        configJson: this.configJson
      }).then(res => {
        this.saving = false;
        if (res.success) {
          this.$Message.success('保存成功');
          this.saveStatus = '保存成功';
          this.saveStatusColor = '#19be6b';
        }
      }).catch(() => {
        this.saving = false;
        this.$Message.error('保存失败');
        this.saveStatus = '保存失败';
        this.saveStatusColor = '#ed4014';
      });
    }
  },
  mounted() {
    this.loadPages();
  }
};
</script>
